/** @jsx jsx */
import { jsx } from "@emotion/core";
import { connect } from "react-redux";
import Blogs from "./Blogs";

function CSSPage({ blogs }) {
  return (
    <Blogs
      blogData={blogs}
      header="CSS Tricks"
      subHeader="Javascript sucks. A CSS master knows most of what you want can be done with CSS."
    />
  );
}

const select = ({ blogs }) => ({
  blogs: blogs.filter(item => item.fields.topic === "css")
});

export default connect(select)(CSSPage);